var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.976 188.976",
    height: 120.976,
    width: 120.976,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 21.26,21.26 h 99.213 v 99.212 H 21.26 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath56",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 21.26,21.26 h 99.213 v 99.212 H 21.26 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,188.976)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    style: {
      fill: "#516e58",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0.014 H 141.689 V 141.732 H 0 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.0859,70.8661)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,-26.631 -21.589,-48.221 -48.22,-48.221 -26.631,0 -48.22,21.59 -48.22,48.221 0,26.631 21.589,48.22 48.22,48.22 C -21.589,48.22 0,26.631 0,0 Z m -90.627,-22.702 c 0,0 39.132,18.771 51.679,-25.519 m -46.498,17.873 c 0,0 28.795,13.319 35.337,-18.594 m -3.136,25.294 c 0,0 23.455,16.926 48.867,4.288 m -41.816,-12.208 c 0,0 18.075,15.395 37.509,2.321 m -32.834,-10.052 c 0,0 13.847,12.254 24.041,2.053"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.5903,85.2582)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.692,-33.059 m -4.253,25.466 4.581,-6.799 5.026,6.946 m 6.93,-0.57 C 10.473,-17.655 4.33,-24.122 -2.13,-23.372 c -6.46,0.749 -10.79,8.432 -9.671,18.071 1.118,9.639 7.262,17.584 13.722,16.834 6.46,-0.75 10.79,-9.91 9.671,-19.549 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.7056,34.0155)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 14.198,5.516 17.108,-8.945"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.9336,73.9696)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -6.693,-7.157 -12.493,-2.398 0,0 -9.428,9.407 4.442,16.102 0,0 -7.342,10.373 5.141,15.562 0,0 9.835,3.991 13.113,-8.116 0,0 8.52,0.641 8.31,-10.066 C 18.514,11.084 17.738,-4.564 0,0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.79,75.1522)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 4.79,4.826"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.9336,74.5609)",
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -4.425,7.06"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.3467,54.1102)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.534,35.378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath56)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.9541,62.6786)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 3.995,-0.14 7.588,2.301 7.766,7.39 7.943,12.479 4.849,16.718 0.854,16.857 -3.142,16.997 -6.524,12.985 -6.701,7.896 -6.879,2.807 -3.995,0.14 0,0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.3828,55.494)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.773,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.79,10.979"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bd75073.svg";
export { ForwardRef as ReactComponent };